import React from 'react';

import ajaxer from '../ajax';
import formatArticle from '../format-article';
import ArticleBox from '../api/components/ArticleBox';
import { NEW_ON_TRIB_API_URL } from './constants';

import { IApiResponse, IApiArticle, IArticle, IGaLabel } from '../types';

export interface INewOnTribProps {
  ga: IGaLabel;
  scrollTarget: HTMLElement;
  headingLevel?: number;
}

async function fetchData(): Promise<IArticle[]> {
  const {
    data: { results },
  } = await ajaxer.get<IApiResponse<IApiArticle>>(NEW_ON_TRIB_API_URL);

  return results.map(result => formatArticle(result));
}

const NewOnTrib: React.FC<INewOnTribProps> = ({
  ga,
  scrollTarget,
  headingLevel = 3,
}) => {
  const renderHeading = (): React.ReactNode => 'New on the Tribune';

  return (
    <ArticleBox
      display={{ hasStyledBorder: true }}
      fetchData={fetchData}
      ga={{ label: ga.label, action: 'recent stories' }}
      headingLevel={headingLevel}
      renderHeading={renderHeading}
      scrollTarget={scrollTarget}
    />
  );
};

export default NewOnTrib;
